import _ from "lodash";
import { useTranslation } from "react-i18next";
import { RootState, useSelector } from "src/store";
import { makeStyles } from "tss-react/mui";

import { selectDevicesByGroupId } from "@dashboard/devices/store/selectors/devices";
import { Theme, useTheme } from "@mui/material";
import { Tooltip } from "@shared/Tooltip";
import { CellContext } from "@tanstack/react-table";

import { GroupOverviewData } from "../../GroupPage.utils";

const useStyles = makeStyles<{ color: string }>()((theme: Theme, { color }) => ({
    tooltip: {
        display: "flex",
        justifyContent: "center",
        marginRight: theme.spacing(1),
    },
    icon: {
        color,
        display: "inline-block",
        verticalAlign: "middle",
    },
}));

export const ComplianceStatusIcon = (props: CellContext<GroupOverviewData, unknown>) => {
    const value = _.toNumber(_.trimEnd(props.getValue<string>(), "%"));
    const theme = useTheme();
    const { t } = useTranslation(["pages"]);

    const groupDevices = useSelector((state: RootState) => selectDevicesByGroupId(state, props.row.original.id));
    const policyNotDefined = props.row.original.compliantDevicePercentage === "";
    const hasNonCompliantDevices = value < 100;

    let iconClassName;
    let color;
    let tooltipText;

    if (policyNotDefined) {
        iconClassName = "fa-regular fa-circle";
        color = theme.palette.emteria.text.secondary;
        tooltipText = !groupDevices.length
            ? t("pages:groupPage.tooltip.groupIsEmpty")
            : t("pages:groupPage.tooltip.noPolicyDefined");
    } else if (hasNonCompliantDevices) {
        iconClassName = "fa-solid fa-circle-exclamation";
        color = theme.palette.emteria.warning;
        tooltipText =
            value === 0 ? t("pages:groupPage.tooltip.noDevicesCompliant") : t("pages:groupPage.tooltip.someDevicesNotCompliant");
    } else {
        iconClassName = "fa-solid fa-circle-check";
        color = theme.palette.emteria.success;
        tooltipText = t("pages:groupPage.tooltip.allDevicesCompliant");
    }

    const { classes } = useStyles({ color });

    return (
        <Tooltip title={tooltipText} className={`${classes.tooltip}`}>
            <span className={classes.icon}>
                <i className={iconClassName} />
            </span>
        </Tooltip>
    );
};
